import { combineReducers } from "redux";

import customers, { CustomersState } from "./customers";
import discountCodes, { DiscountCodesState } from "./discountCodes";
import discountCodesLogs, { IDiscountCodesLogsState } from "./discountCodesLogs";
import plans, { PlansState } from "./plans";
import feed, { FeedState } from "./feed";
import userDiscountCodes, { IUserDiscountCodesState } from "./userDiscount";
import agents, { IAgentsState } from "./agents";
import charges, { IDayChargesState } from "./charges";
import latestCharges from "./latestFailedCharges";
import agentsLogsActivityReducer, { IAgentsActivityLogsState } from "./agentsLogsActivity";
import fundedTraders, { IFundedTradersState } from "./fundedTraders";
import fundedTrader, { IFundedTraderState } from "./fundedTrader";
import evaluations, { IEvaluationsState } from "./evaluations";
import rithmicAccounts, { IRithmicAccountsState } from "./rithmicAccounts";
import customer, { ICustomerState } from "./customer";
import suspiciousCustomers, { ISuspiciousCustomersState } from "./suspiciousCustomers";
import heliosAdmin, { IHeliosAdminState } from "./heliosAdmin";
import forcedToLiveAccounts, { IForcedToLiveAccountsState } from "./forcedToLiveAccounts";
import fundedTraderFiles, { IFundedTraderFilesState } from "./fundedTraderFiles";
import agent, { IAgentState } from "./agent";
import polices, { IPolicesState } from "./polices";
import fundedTradersStatusesList, {
  IFundedTradersStatusesListState,
} from "./fundedTradersStatusesList";
import affiliates, { IAffiliatesState } from "./affiliates";
import complianceSearch, { IComplianceSearchAccountsState } from "./complianceSearch";
import financials, { IFinancialsState } from "./financials";
import fundedCompliance, { IFundedComplianceState } from "./FundedCompliance";
import fundedComplianceProfile, { IFundedComplianceProfileState } from "./fundedComplianceProfile";

export interface ReduxState {
  agent: IAgentState;
  agents: IAgentsState;
  agentsLogsActivityReducer: IAgentsActivityLogsState;
  affiliates: IAffiliatesState;
  charges: IDayChargesState;
  customer: ICustomerState;
  customers: CustomersState;
  discountCodes: DiscountCodesState;
  discountCodesLogs: IDiscountCodesLogsState;
  evaluations: IEvaluationsState;
  feed: FeedState;
  forcedToLiveAccounts: IForcedToLiveAccountsState;
  fundedTrader: IFundedTraderState;
  fundedTraders: IFundedTradersState;
  fundedTraderFiles: IFundedTraderFilesState;
  fundedTradersStatusesList: IFundedTradersStatusesListState;
  financials: IFinancialsState;
  heliosAdmin: IHeliosAdminState;
  latestCharges: IDayChargesState;
  plans: PlansState;
  polices: IPolicesState;
  rithmicAccounts: IRithmicAccountsState;
  suspiciousCustomers: ISuspiciousCustomersState;
  userDiscountCodes: IUserDiscountCodesState;
  complianceSearch: IComplianceSearchAccountsState;
  fundedCompliance: IFundedComplianceState;
  fundedComplianceProfile: IFundedComplianceProfileState;
}

export default combineReducers({
  agent,
  agents,
  agentsLogsActivityReducer,
  affiliates,
  charges,
  customer,
  customers,
  complianceSearch,
  discountCodes,
  discountCodesLogs,
  evaluations,
  feed,
  forcedToLiveAccounts,
  fundedTrader,
  fundedTraders,
  fundedTraderFiles,
  fundedTradersStatusesList,
  fundedCompliance,
  fundedComplianceProfile,
  financials,
  heliosAdmin,
  latestCharges,
  plans,
  polices,
  rithmicAccounts,
  suspiciousCustomers,
  userDiscountCodes,
});
